import { createStructuredSelector } from 'reselect';
import {
  apiBaseUrlSelector,
  tokenSelector,
  propertySelector,
  taxingUnitSelector,
  captchaKeySelector,
  officeSelector,
  clientConfigSelector,
  currentYearSelector
} from '../../selectors/global';

export default createStructuredSelector({
  apiBaseUrl: apiBaseUrlSelector,
  currentYear: currentYearSelector,
  token: tokenSelector,
  captchaKey: captchaKeySelector,
  property: propertySelector,
  taxingUnit: taxingUnitSelector,
  office: officeSelector,
  clientConfig: clientConfigSelector
});
